const SearchIcon = ({ fill = "#fff", height = 24, width = 24 }) => (
	<svg width={height} height={width} viewBox="0 0 24 24">
		<g
			fill="none"
			stroke={fill}
			strokeLinejoin="round"
			strokeWidth="2"
			transform="translate(5 5)"
		>
			<circle cx="6" cy="6" r="6" />
			<path
				strokeLinecap="round"
				d="M11.051 11.017L13.704 15.142"
				transform="rotate(-10 12.377 13.08)"
			/>
		</g>
	</svg>
);

export default SearchIcon;
